import html2pdf from "html2pdf.js";

/**
 * Export provided HTML content as a downloadable PDF file.
 *
 * @param {string} content - The inner HTML content to render.
 * @param {string} fileName - The desired filename without extension (optional).
 */
export const exportPrescriptionPDF = async (content, fileName = "prescription", pdf) => {
  if (!content) {
    console.error("No content provided for PDF export.");
    return;
  }

  const html = `
    <div style="
      width: 800px;
      padding: 10px;
      font-family: Arial, sans-serif;
      margin: auto;
      box-sizing: border-box;
    ">
      ${content}
    </div>
  `;
  if (pdf) {
    try {
      // Generate PDF as Blob
      const pdfBlob = await html2pdf()
        .set({
          margin: [5, 5, 5, 5],
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(html)
        .outputPdf("blob");
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(",")[1]); // strip `data:application/pdf;base64,`
        reader.onerror = reject;
        reader.readAsDataURL(pdfBlob);
      });

      return {
        fileName: `${fileName}.pdf`,
        base64: base64Data,
      };
    } catch (error) {
      console.error("PDF generation failed:", error);
      return null;
    }
  }
  html2pdf()
    .set({
      margin: [5, 5, 5, 5],
      filename: `${fileName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(html)
    .save()
    .catch((err) => console.error("PDF generation failed:", err));
};